import React, {useState, useEffect, useContext} from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faExternalLinkAlt, faTimesCircle, faCheckCircle, faCalendarAlt, faCodeBranch, faUser, faCog } from "@fortawesome/free-solid-svg-icons";
import { faBootstrap, faGithub, faJs, faReact, faSass } from "@fortawesome/free-brands-svg-icons";
import { Image, Button, Container, Navbar, Nav, Badge } from '@themesberg/react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { Routes } from "../routes";
import { HashLink } from 'react-router-hash-link';
import ReactHero from "../assets/img/technologies/Logo_ME_color_white_RGB.png";
import AuthContext from "../context/AuthContext";

export default () => {
  const { user, signOut } = useContext(AuthContext);

  const handleLogout = (e) => {
      window.localStorage.clear()
      signOut();
  }

  // Checks config permission attribute
  const canViewConfig = user["custom:can_view_config"] === "true";

  return (
  <>
      <Navbar variant="dark" expand="lg" bg="dark" className="navbar-transparent navbar-theme-primary sticky-top">
        <Container className="position-relative justify-content-between px-3">
          {/* Brand */}
          <Navbar.Brand as={Link} to={Routes.SCT.path} className="me-lg-3 d-flex align-items-center">
            <Image src={ReactHero} />
            <span className="ms-2 brand-text d-none d-md-inline">SCT</span>
          </Navbar.Brand>

          {/* Left side tabs */}
          <Nav variant="tabs" className="me-auto">
            <Nav.Item>
              <Nav.Link
                as={NavLink}
                to={Routes.SCT.path}
                exact
              >
                Dashboard
              </Nav.Link>
            </Nav.Item>

            {canViewConfig && (
              <Nav.Item>
                <Nav.Link
                  as={NavLink}
                  to={Routes.Configuration.path}
                >
                  <FontAwesomeIcon icon={faCog} className="me-1" />
                  Configuration
                </Nav.Link>
              </Nav.Item>
            )}

          </Nav>

          {/* Right side user + logout */}
          <div className="d-flex align-items-center">
            <Navbar.Text className="justify-content-center px-2">
              <FontAwesomeIcon icon={faUser} className="me-1" />
              <strong>{user["cognito:username"] || []}</strong>
            </Navbar.Text>
            <Button
              variant="light"
              as={Link}
              to={Routes.Signin.path}
              onClick={handleLogout}
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="me-1" /> Logout
            </Button>
          </div>
        </Container>
      </Navbar>
  </>
  );
};